/* eslint-disable */
require('./budget-left')
require('./budget-left-ir')
require('./child')
require('./infant')
require('./marriage')
require('./pet')
require('./teenager')
require('./child2')
require('./infant2')
require('./marriage2')
require('./pet2')
require('./teenager2')
